import { PublicLayoutService } from '../../../services/public-layout.service';

export class PublicLayoutBase {
	constructor(protected publicLayoutService: PublicLayoutService) {}

	// call method in PublicLayoutService when the public layout is rendered
	public finishedRendering() {
		this.publicLayoutService.onPublicLayoutRendered.emit(true);
	}
}
